import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './modal-header.scss';
import withFontClassName from '../../../hoc/with-font-class-name';

const ModalHeader = ({ children, titleFontClassName, className, dataHook }) => (
  <h2
    className={classNames(
      styles.title,
      titleFontClassName,
      className,
      'default-desktop-header-text-color',
    )}
    data-hook={dataHook}
  >
    {children}
  </h2>
);

ModalHeader.propTypes = {
  children: PropTypes.any,
  titleFontClassName: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataHook: PropTypes.string,
};

export default withFontClassName(ModalHeader);
